import { starColors } from '@/constants/starColors';
import { TrustPilotStar } from './TrustPilotStar';
export const TrustPilotRating = ({
  stars
}: {
  stars?: number;
}) => {
  const currentStars = stars ?? 4.5;
  const starColor = starColors.get(currentStars);
  const wholeStars = Math.floor(currentStars);
  const showHalfStar = currentStars - wholeStars > 0;
  const grayStars = 5 - wholeStars - (showHalfStar ? 1 : 0);
  return <div className="flex flex-row items-center gap-1" data-sentry-component="TrustPilotRating" data-sentry-source-file="TrustPilotRating.tsx">
      {Array.from({
      length: wholeStars
    }).map((_, index) => <TrustPilotStar filledBackgroundColor={starColor} key={index} />)}
      {showHalfStar && <TrustPilotStar filledBackgroundColor={starColor} isFilled="half" />}
      {Array.from({
      length: grayStars
    }).map((_, index) => <TrustPilotStar key={index} isFilled={false} />)}
    </div>;
};